import React from 'react';
import './GrayCard.css';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';


class GrayCardMember extends React.Component {
    state = {
    }
    renderTitle() {
        if (this.props.type === "amount") {
            return (
                <div className=""> <span className="">{this.props.amount}</span></div>
            )
        } else if (this.props.type === "items") {
            return (
                <div className=""> <span className="">{this.props.items} (Items)</span></div>
            )

        }
    }

    renderArrow() {
        if (isNaN(Number(this.props.growthAmount))) {

            return (<div >NA</div>
            );
        }
        if (this.props.growth === "positive") {
            return (<div >{Number(this.props.growthAmount).toFixed(2)}  <Link className = "success"> <i className="fas fa-arrow-circle-up green"></i></Link></div>

            )
        } else if (this.props.growth === "negative") {
            return (
                <div >{Number(this.props.growthAmount).toFixed(2)}  <Link className = "danger"><i className="fas fa-arrow-circle-down red"></i></Link></div>
            )
        }
    }

    renderDate() {
        if (this.props.updatedDate != null) {
            return (<div >{this.props.updatedDate}</div>
            );
        }
        else {
            return (<div >NA</div>
            );
        }
    }

    displayModalForRebate() {
        let propsForModal = {
            title: this.props.title,
            purchaseAmount: this.props.purchaseAmount,
            rebateInfo: this.props.rebateInfo

        }
        this.props.displayModal(propsForModal);
    }

    displayModal() {
        let propsForModal = {
            title: this.props.title,
            amount: this.props.amount,
            items: this.props.items,
            type: this.props.type,
            date: this.props.date,
            growthAmount: this.props.growthAmount,
            growth: this.props.growth,
            excessRevenue: this.props.excessRevenue

        }
        console.log('i got all info , now going back to bh verified');
        this.props.displayModal(propsForModal);
    }

    renderDate() {
        if (this.props.updatedDate != null) {
            return (<div >{this.props.updatedDate}</div>
            );
        }
        else {
            return (<div >NA</div>
            );
        }
    }

    renderRebateCard = () => {
        console.log(this.props);
        return (
            <div className="col-sm-3 ">

                <div className=" grayCards panel panel-card" >
                    <div className="panel-body">
                        <div className="panel-title minHeightTitle"><span>{this.props.title} </span></div>
                        <div className="">
                            <div >
                                Purchase Amount : {this.props.purchaseAmount}
                            </div>
                        </div>
                    </div>
                    <div className="panel-footer">
                        <span>Click here for Rebate information</span>
                    </div>
                </div>
            </div>
        )
    }
    renderExcessCard = () => {
        console.log(this.props);
        return (
            <div className="col-sm-3 ">

                <div className=" grayCards panel panel-card" >
                    <div className="panel-body">
                        <div className="panel-title minHeightTitle"><span>{this.props.title} </span></div>
                        <div className="">
                            <div >
                                <h3 style={{ fontSize: "20px" }}>{this.props.excessRevenue}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="panel-footer">
                        {/* <div className="updatedOn"><span style={{marginRight:"5px"}}>YOY</span></div>
                        <div className="figures">
                            {this.renderArrow()}
                        </div> */}

                    </div>
                </div>
            </div>
        )
    }
    renderTitleIfRebateFilteredOrNot() {

        if (this.props.title.substring(2, 0) === "BH" || this.props.title.substring(2, 0) === "Bh") {
            return (
                <div className="panel-title minHeightTitle" style={{ color: "#00bcd4" }}><span>{this.props.title} </span></div>
            )
        }
        else if (this.props.title === "Total Rebate Estimate") {
            return (
                <div className="panel-title minHeightTitle"><span>Total Estimated Rebate</span></div>
            )
        }
        else if (this.props.title === "Estimated Growth Rebate"){
            return (
                <div className="panel-title minHeightTitle"><span>Estimated Group Growth Rebate</span></div>
            )
        }
        return (
            <div className="panel-title minHeightTitle"><span>{this.props.title} </span></div>
        )

    }
    render() {
        const { show } = this.props;
        if (this.props.type === "rebateCard") {
            return this.renderRebateCard()
        }
        if (this.props.title === "Excess Revenue Points") {
            return "";
        }
        if (this.props.title === "Total Purchases") {
            return (
                <div className="col-sm-3 ">
                    <OverlayTrigger overlay={(<Tooltip id="callModal">Rebateable IMARK Verified Purchases</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                        <div className=" grayCards panel panel-card" >
                            <div className="panel-main">
                                {this.renderTitleIfRebateFilteredOrNot()}
                                <div className="panel-value">

                                    {/* will print $ or items based on type */}
                                    {this.renderTitle()}

                                </div>
                            </div>
                            {this.props.updatedDate != null ?
                                <React.Fragment>
                                    <hr />
                                    <div className="panel-footer">
                                        <div className="updatedOn"><span style={{ marginRight: "5px" }}>Last Updated Date</span></div>
                                        <div className="figures">
                                            {this.renderDate()}
                                        </div>

                                    </div>
                                </React.Fragment> : ""
                            }
                            <hr />
                            <div className="panel-footer">
                                <div className="updatedOn"><span style={{ marginRight: "5px" }}>YOY</span></div>
                                <div className="figures">
                                    {this.renderArrow()}
                                </div>

                            </div>

                        </div></OverlayTrigger>
                </div>
            )
        }

        if (this.props.title === "Base Rebate") {
            return (
                <div className="col-sm-3 ">
                    <OverlayTrigger overlay={(<Tooltip id="callModal">IMARK Verified Flat/Base Rebate</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                        <div className=" grayCards panel panel-card" >
                            <div className="panel-main">
                                {this.renderTitleIfRebateFilteredOrNot()}
                                <div className="panel-value">

                                    {/* will print $ or items based on type */}
                                    {this.renderTitle()}

                                </div>
                            </div>
                            {this.props.updatedDate != null ?
                                <React.Fragment>
                                    <hr />
                                    <div className="panel-footer">
                                        <div className="updatedOn"><span style={{ marginRight: "5px" }}>Last Updated Date</span></div>
                                        <div className="figures">
                                            {this.renderDate()}
                                        </div>

                                    </div>
                                </React.Fragment> : ""
                            }
                            <hr />
                            <div className="panel-footer">
                                <div className="updatedOn"><span style={{ marginRight: "5px" }}>YOY</span></div>
                                <div className="figures">
                                    {this.renderArrow()}
                                </div>

                            </div>

                        </div></OverlayTrigger>
                </div>
            )
        }

        if (this.props.title === "FBI Rebate") {
            return (
                <div className="col-sm-3 ">
                    <OverlayTrigger overlay={(<Tooltip id="callModal">IMARK Verified FBI Rebate</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                        <div className=" grayCards panel panel-card" >
                            <div className="panel-main">
                                {this.renderTitleIfRebateFilteredOrNot()}
                                <div className="panel-value">

                                    {/* will print $ or items based on type */}
                                    {this.renderTitle()}

                                </div>
                            </div>
                            {this.props.updatedDate != null ?
                                <React.Fragment>
                                    <hr />
                                    <div className="panel-footer">
                                        <div className="updatedOn"><span style={{ marginRight: "5px" }}>Last Updated Date</span></div>
                                        <div className="figures">
                                            {this.renderDate()}
                                        </div>

                                    </div>
                                </React.Fragment> : ""
                            }
                            <hr />
                            <div className="panel-footer">
                                <div className="updatedOn"><span style={{ marginRight: "5px" }}>YOY</span></div>
                                <div className="figures">
                                    {this.renderArrow()}
                                </div>

                            </div>

                        </div></OverlayTrigger>
                </div>
            )
        }

        if (this.props.title === "Estimated Gain Share") {
            return (
                <div className="col-sm-3 ">
                    <OverlayTrigger overlay={(<Tooltip id="callModal">IMARK Verified Total Rebate Earned</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                        <div className=" grayCards panel panel-card" >
                            <div className="panel-main">
                                {this.renderTitleIfRebateFilteredOrNot()}
                                <div className="panel-value">

                                    {/* will print $ or items based on type */}
                                    {this.renderTitle()}

                                </div>
                            </div>
                            {this.props.updatedDate != null ?
                                <React.Fragment>
                                    <hr />
                                    <div className="panel-footer">
                                        <div className="updatedOn"><span style={{ marginRight: "5px" }}>Last Updated Date</span></div>
                                        <div className="figures">
                                            {this.renderDate()}
                                        </div>

                                    </div>
                                </React.Fragment> : ""
                            }
                            <hr />
                            <div className="panel-footer">
                                <div className="updatedOn"><span style={{ marginRight: "5px" }}>YOY</span></div>
                                <div className="figures">
                                    {this.renderArrow()}
                                </div>

                            </div>

                        </div></OverlayTrigger>
                </div>
            )
        }

        if (this.props.title === "Total Estimated Rebate") {
            return (
                <div className="col-sm-3 ">
                    <OverlayTrigger overlay={(<Tooltip id="callModal">IMARK Verified {this.props.title}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                        <div className=" grayCards panel panel-card" >
                            <div className="panel-main">
                                {this.renderTitleIfRebateFilteredOrNot()}
                                <div className="panel-value">

                                    {/* will print $ or items based on type */}
                                    {this.renderTitle()}

                                </div>
                            </div>
                            {this.props.updatedDate != null ?
                                <React.Fragment>
                                    <hr />
                                    <div className="panel-footer">
                                        <div className="updatedOn"><span style={{ marginRight: "5px" }}>Last Updated Date</span></div>
                                        <div className="figures">
                                            {this.renderDate()}
                                        </div>

                                    </div>
                                </React.Fragment> : ""
                            }
                            <hr />
                            <div className="panel-footer">
                                <div className="updatedOn"><span style={{ marginRight: "5px" }}>YOY</span></div>
                                <div className="figures">
                                    {this.renderArrow()}
                                </div>

                            </div>

                        </div></OverlayTrigger>
                </div>
            )
        }

        if (this.props.title === "Estimated Growth Rebate") {
            return (
                <div className="col-sm-3 ">
                    <OverlayTrigger overlay={(<Tooltip id="callModal">IMARK Verified {this.props.title}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                        <div className=" grayCards panel panel-card" >
                            <div className="panel-main">
                                {this.renderTitleIfRebateFilteredOrNot()}
                                <div className="panel-value">

                                    {/* will print $ or items based on type */}
                                    {this.renderTitle()}

                                </div>
                            </div>
                            {this.props.updatedDate != null ?
                                <React.Fragment>
                                    <hr />
                                    <div className="panel-footer">
                                        <div className="updatedOn"><span style={{ marginRight: "5px" }}>Last Updated Date</span></div>
                                        <div className="figures">
                                            {this.renderDate()}
                                        </div>

                                    </div>
                                </React.Fragment> : ""
                            }
                            <hr />
                            <div className="panel-footer">
                                <div className="updatedOn"><span style={{ marginRight: "5px" }}>YOY</span></div>
                                <div className="figures">
                                    {this.renderArrow()}
                                </div>

                            </div>

                        </div></OverlayTrigger>
                </div>
            )
        }

        return (
            <div className="col-sm-3 ">
                <OverlayTrigger overlay={(<Tooltip id="callModal">{this.props.title} From IMARK Verified Data</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                    <div className=" grayCards panel panel-card" >
                        <div className="panel-main">
                            {this.renderTitleIfRebateFilteredOrNot()}
                            <div className="panel-value">

                                {/* will print $ or items based on type */}
                                {this.renderTitle()}

                            </div>
                        </div>
                        {this.props.updatedDate != null ?
                            <React.Fragment>
                                <hr />
                                <div className="panel-footer">
                                    <div className="updatedOn"><span style={{ marginRight: "5px" }}>Last Updated Date</span></div>
                                    <div className="figures">
                                        {this.renderDate()}
                                    </div>

                                </div>
                            </React.Fragment> : ""
                        }
                        <hr />
                        <div className="panel-footer">
                            <div className="updatedOn"><span style={{ marginRight: "5px" }}>YOY</span></div>
                            <div className="figures">
                                {this.renderArrow()}
                            </div>

                        </div>

                    </div></OverlayTrigger>
            </div>
        )
    }
}

    export default GrayCardMember;